import { render, staticRenderFns } from "./one-project.vue?vue&type=template&id=0ae4f7f3"
import script from "./one-project.vue?vue&type=script&lang=js"
export * from "./one-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports